// globals
class Barba {
  constructor(){
    this.event();
  }
  event(){
    barba.init({
      preventRunning: true,
      transitions: [
        {
          once(data) {
            contentListSwiper(); // Swiperの初期化関数を呼び出す
            detailContentSwiper();
            footerPagenation();
            bgmStart();
            const barbaBody = document.querySelector('.js-barba-body');
            gsap.to(barbaBody, {
              opacity: 1,
              duration: 0.8
            });
            if(data.next.namespace == 'home') {
              homeMvMovieLoop()
            }else {
              backTop(data.next.namespace);
            }
          },
          async leave(data) {
            // フェードアウト
            const container = data.current.container;
            await gsap.to(container, {
              opacity: 0,
              duration: 0.4
            });
          },
          enter(data) {
            // preventRunning: true,で解決したのでコメントアウト
            // $('body').css('pointer-events','none');
            // setTimeout(function(){
            //   $('body').css('pointer-events','');
            // },500)
            if(data.next.namespace === 'list') {
              contentListSwiper(); // Swiperの初期化関数を再度呼び出す
            }
            detailContentSwiper();
            window.scrollTo(0, 0);
          },
          async after(data) {
            // 新しいページのDOMが完全に読み込まれた後の処理
            const container = data.next.container;
            // フェードイン
            await gsap.to(container, {
              opacity: 1,
              duration: 0.4
            });
            footerPagenation();
          },
          afterEnter(data){
            if(data.next.namespace == 'home') {
              homeMvMovieLoop()
            }else {
              backTop(data.next.namespace);
              qrCodeToggle();
            }
          }
        },
      ],
      views: [
        {
          namespace: 'home',
          beforeEnter(data) {
            footerToggle('home')
          }
        },
        {
          namespace: 'about-hyundai',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'mocean',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'ioniq5',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'kona',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'n-brand-story',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'green-action',
          beforeEnter(data) {
            footerToggle('detail')
          }
        },
        {
          namespace: 'artworks-credit',
          beforeEnter(data) {
            footerToggle('list')
          }
        },
        {
          namespace: 'list',
          beforeEnter(data) {
            footerToggle('list')
          }
        },
      ]
    });
    

    function contentListSwiper() {
      let thisSwiper = new Swiper('.js-content-list-swiper', {
        loop: true, // ループの有効化
        allowTouchMove: false,
        effect: 'fade',
        speed: 1000,
        autoplay: { // 自動再生させる
          delay: 6500, // 次のスライドに切り替わるまでの時間（ミリ秒）
        },
      });
    }

    detailContentSwiper();
    function detailContentSwiper() {
      const swiperWrap = '.js-content-swiper';
      $(swiperWrap).each(function(){
        const thisData = $(this).data('swiper');
        let detailSwiper = new Swiper('[data-swiper="'+thisData+'"] .js-detail-swiper', {
          loop: false, // ループの有効化
          allowTouchMove: false,
          navigation: {
            nextEl: '[data-swiper="'+thisData+'"] .swiper-next',
            prevEl: '[data-swiper="'+thisData+'"] .swiper-prev',
          },
          pagination: {
            el: '[data-swiper="'+thisData+'"] .swiper-pagination',
            type: 'fraction', // 分数表示を指定
          },
        });
        let thumbSwiper = new Swiper('[data-swiper="'+thisData+'"] .js-thumb-swiper', {
          loop: false, // ループの有効化
          centeredSlides: true,
          slidesPerView: 2.7,
          speed: 500,
          thumbs: {
            swiper: detailSwiper
          },
          on: {
            // サムネイルSwiperのスライド変更時にメインSwiperを更新
            slideChange: function () {
              let newIndex = this.realIndex;
              detailSwiper.slideTo(newIndex);
            },
            init: function () {
              // Swiperの初期化が完了したら、swiper-slideのtransition-durationを変更する
              setTimeout(function(){
                $('.swiper-slide').css('transition', 'all 0.5s');
              },500)
            }
          }
        });
        detailSwiper.on('slideChange', function () {
          let newIndex = this.realIndex;
          thumbSwiper.slideTo(newIndex);
        });
      })
    }

    function footerPagenation() {
      const nextLinkTarget = '.js-pagenation-next';
      const prevLinkTarget = '.js-pagenation-prev';
      const linkWrap = '.js-pagenation';
      const nextLink = $(linkWrap).data('next');
      const prevLink = $(linkWrap).data('prev');
      $(nextLinkTarget).attr('href',nextLink);
      $(prevLinkTarget).attr('href',prevLink);


      // preventRunning: true,で解決したのでコメントアウト
      // $(nextLinkTarget + ', ' + prevLinkTarget).on('click', function(e) {
      //   if ($(this).attr('href') == '#') {
      //     e.preventDefault(); // クリックを防止
      //     return; // 早期リターン
      //   }
      // });
    }

    function footerToggle(target) {
      const toggleElement = '.js-footer-toggle';
      $(toggleElement).each(function() {
        const thisTargets = $(this).data('toggle-active');
        // データ属性を配列として取得（複数の値を想定し、半角スペースで分割）
        const targetsArray = thisTargets.split(' ').filter(item => item.trim() !== '');
        // ターゲットが配列内に存在するかチェック
        if (targetsArray.includes(target)) {
          $(this).removeClass('is-hidden');
        } else {
          $(this).addClass('is-hidden');
        }
      });
    }
    

    // 5分後にTOPページ
    function backTop(page) {
      setupListeners();
      clearTimeout(window.backTopTimeoutId);
    
      window.backTopTimeoutId = setTimeout(() => {
        if(page != 'home'){
          barba.go('/')
        }
      }, 1800000); // 30分
    }
    
    // ユーザーの操作を検出するイベントリスナーを設定
    function setupListeners() {
      const events = ['mousemove', 'mousedown', 'touchstart', 'click', 'keydown', 'scroll'];
      events.forEach(event => {
        document.addEventListener(event, resetTimer, false);
      });
    }
    
    function resetTimer() {
      clearTimeout(window.backTopTimeoutId);
      window.backTopTimeoutId = setTimeout(() => {
        barba.go('/');
      }, 1800000); // 30分後にトップページにリダイレクト
    }

    // TOPページの動画ループ
    function homeMvMovieLoop() {
      const videoLooper = new VideoLooper(".js-home-movie"); // video-classはビデオ要素の共通クラス
      videoLooper.playFirstVideo();
    }

    // QRコードの実装
    function qrCodeToggle() {
      const qrModal = new QrModal('js-btn-qr');
    }

    // BGM再生
    function bgmStart() {
      document.addEventListener('click', function () {
        const bgm = document.getElementById('bgm');
        bgm.muted = true; // ブラウザの自動再生ポリシーを回避するために最初はミュート
        bgm.play().then(() => {
            // console.log("自動再生に成功しました");
            bgm.muted = false;
        }).catch(error => {
            // console.log("自動再生に失敗しました", error);
        });
      })
    }

  }
}

var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class ContentListSwiper {
  constructor(el,opt){
    this.el = el;
  }
  event(){
    const contentListSwiper = '.js-content-list-swiper';
    const thisSwiper = new Swiper(contentListSwiper, {
      loop: true, // ループの有効化
      allowTouchMove: false,
      effect: 'fade',
      autoplay: { // 自動再生させる
        delay: 5000, // 次のスライドに切り替わるまでの時間（ミリ秒）
      },
    });
  }

}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class QrModal {
  constructor(){
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalLink = '.js-btn-qr';
    const modalWrap = '.js-qr-modal';
    const modalCover = '.js-modal-cover';
    const modalClose = '.js-qr-modal-close';
    const qr = '.js-qr';
    let qrCode;
    $(modalLink).on('click',function(e){
      e.preventDefault();
      $(qr).attr('src','');
      qrCode = $(this).data('qr');
      $(qr).attr('src',qrCode);
      $(modalCover).fadeIn();
      $(modalWrap).addClass('is-active');
    })
    $(modalClose).on('click',function(e){
      e.preventDefault();
      $(modalCover).fadeOut();
      $(modalWrap).removeClass('is-active');
    })
    
  }
}

class VideoLooper {
  constructor(videoSelector) {
    this.videos = $(videoSelector).toArray();
    this.currentIndex = 0;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.videos.forEach((video, index) => {
      $(video).on("ended", () => this.onVideoEnded(index));
    });
  }

  onVideoEnded(index) {
    $(this.videos[index]).fadeOut();
    this.currentIndex = (index + 1) % this.videos.length;
    const nextVideo = this.videos[this.currentIndex];
    $(nextVideo).fadeIn();
    nextVideo.play();
  }

  playFirstVideo() {
    $(this.videos[0]).fadeIn();
    this.videos[0].play();
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let barba = new Barba();
  let qrModal = new QrModal();
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  // let contentListSwiper = new ContentListSwiper('');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });